export const normalizeMessage = (message) => {
  switch (message) {
    case "Payment source registered successfully":
      return "has conectado tu banco exitosamente";
    case "Token generado y OTP enviado correctamente.":
      return "Notificación enviada correctamente";

    default:
      return message;
  }
};
